import { gtagMixin } from "../../mixins/gtag-mixin";
import { mediaQuery } from "../../mixins/media-query";

export default {
  props: ["isEmployment"],
  mixins: [gtagMixin, mediaQuery],
  data() {
    return {
      isScrolled: false, // Inicialmente, el encabezado no está desplazado
    };
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    scrollTop() {
      window.scrollTo({
        top: 0,
      });
    },
    handleScroll() {
      this.isScrolled = !(window.scrollY === 0);
    },
    scrollIntoView(scrollTo) {
      if (scrollTo == "#Inicio") {
        window.scrollTo({
          top: 0,
          behavior: "smooth",
        });
      } else {
        const el = scrollTo ? document.querySelector(scrollTo) : null;
        if (el) {
          el.scrollIntoView({ behavior: "smooth" });
        }
      }
    },
  },
};
